/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2018, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'

import {
  sortDates
} from '../../utils'

const sortItems = (items, sortDirection) => {
  let itms = [[], ...items]
  itms.sort((a,b) => sortDates(a.date, b.date, sortDirection === "descending"))
  return itms
}

const getUniqueDatesSorted = (items, sortDirection) => {
  // get unique days on which activities occurred
  let dates = [ ...new Set(
    items.map(item => moment(item.date).format("YYYY-MM-DD"))
  )]

  // sort according to sort direction
  dates.sort((a,b) => sortDates(a, b, sortDirection === "descending"))

  return dates
}


export class ActivityTimeline extends React.Component {
  static propTypes = {
    items: PropTypes.arrayOf(
      PropTypes.shape({
        date: PropTypes.string.isRequired,
        component: PropTypes.element
      }
    )).isRequired,
    groupByDates: PropTypes.bool,
    sort: PropTypes.oneOf(["descending", "ascending"])
  }

  static defaultProps = {
    groupByDates: false,
    sort: "descending"
  }

  state = {
    items: sortItems(this.props.items, this.props.sort),
    dates: getUniqueDatesSorted(this.props.items, this.props.sort)
  }

  componentDidUpdate(prevProps, prevState) {
    if (JSON.stringify(prevProps.items) !== JSON.stringify(this.props.items)) {
      const items = sortItems(this.props.items, this.props.sort)
      const dates = getUniqueDatesSorted(this.props.items, this.props.sort)
      this.setState({ items, dates })
    }
  }

  render() {
    return (
      <div className="slds-size_1-of-1">
        {this.state.dates.map(date => (
          <div key={date}>
            {this.props.groupByDates &&
              <div className="case-note-date slds-col slds-size_1-of-1 slds-m-top_large slds-m-bottom_large">
                {moment(date).format("ddd D MMMM YYYY")}
              </div>
            }
            <ul>
              {this.state.items.map(item => (
                moment(date).isSame(moment(item.date), 'day') &&
                <li key={`${date}_${item.date}`}>
                  {item.component}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/activity-timeline/index.js